import angular from 'angular';

import '../../services/datastorage';
import '../../services/product';
import '../../services/favorites';

angular.module('folkeuni').component('favoriteList', {
  bindings: {    
  },
  controller: function(DataStorage, Favorites, $scope) {
    var $ctrl = this;
    $ctrl.visible = false;
    $ctrl.favoriteList = [];
    $ctrl.showToggle = false;

    $ctrl.toggle = function() {
      if ($ctrl.visible) {
        $ctrl.visible = false;
      }
      else {
        $ctrl.visible = true;
      }
    }

    $ctrl.remove = function(item) {
      if (item && item.id) {
        Favorites.removeAsFavorite(item.id).then(function(list) {
          DataStorage.set('favoriteList', JSON.stringify(list)).then(function() {
            $scope.$emit('updateFavorites', list);
          });
        });
      }
    }

    $ctrl.reload = function() {
      Favorites.getFavorites().then(function(list) {
        $ctrl.favoriteList = list;
        $ctrl.toggleButton();
      });
    }

    $ctrl.toggleButton = function() {
      if ($ctrl.favoriteList && $ctrl.favoriteList.length > 0) {
        $ctrl.showToggle = true;
      }
      else {
        $ctrl.showToggle = false;
      }
    }

    $ctrl.$onInit = function() {
      $ctrl.reload();
    }

    $scope.$on('changeFavorites', function(e, data) {
      $ctrl.favoriteList = data;
      $ctrl.toggleButton();
    });
  },
  templateUrl: '/shop-dist/templates/favorite-list.html',
  transclude: false
});
